// const baseUrl = "http://192.168.0.29:8888"
// const baseUrl = "http://nmxlxh.cn"
// const baseUrl = "http://sdxl.1qit.com"
// const baseUrl = "https://www.sdxlxh.cn" //山东5.7更新
const baseUrl = "http://shanxixl.com"
// const baseUrl = "http://ahsxlxh.cn"
// const baseUrl = "http://jiangsuxinli.cn/" //江苏 备份
// const baseUrl = "http://jsxl.1qit.com"


let wangzhan = {name:'内蒙古',address:'nmxlxh'}
// if (baseUrl.indexOf("nmxlxh.cn") !== -1) {
//   wangzhan = {name:'内蒙古',address:'nmxlxh'}
// }else if(baseUrl.indexOf("sdxl.1qit") !== -1){
//   wangzhan = {name:'山东',address:'sdxl'}
// }else if(baseUrl.indexOf("shanxixl") !== -1){
//   wangzhan = {name:'山西',address:'shanxixl'}
// }else if(baseUrl.indexOf("ahsxlxh") !== -1){
//   wangzhan = {name:'安徽',address:'ahsxlxh'}
// }
if (baseUrl.indexOf("nmxlxh.cn") !== -1) {
  wangzhan = {name:'内蒙古',address:'nmxlxh'}
}else if(baseUrl.indexOf("sdxlxh.cn") !== -1){
  wangzhan = {name:'山东',address:'sdxlxh'}
}else if(baseUrl.indexOf("shanxixl") !== -1){
  wangzhan = {name:'山西',address:'shanxixl'}
}else if(baseUrl.indexOf("ahsxlxh") !== -1){
  wangzhan = {name:'安徽',address:'ahsxlxh'}
}else if(baseUrl.indexOf("jiangsuxinli") !== -1){
  wangzhan = {name:'江苏',address:'jiangsuxinli'}
}

// else if(baseUrl.indexOf("jiangsuxinli") !== -1){
//   wangzhan = {name:'江苏',address:'jiangsuxinli'}
// }
export {
	baseUrl,
	wangzhan
}
 

 